"use strict";

(function () {
    $(document).ready(function () {
        const header = $("header");
        const footer = $("footer");
        const paddings = 100;
        $(".h-100-calc").attr(
            "style",
            "min-height:calc(var(--100vh) - " +
                paddings +
                "px - " +
                header.outerHeight() +
                "px - " +
                footer.outerHeight() +
                "px)"
        );
    });
})();
